<template>
  <div>
    <div class="impressum">
      <h1>{{ $t("Impressum") }}</h1>
      <p>{{ $t("shop_impressumVerantwortung") }}</p>
      <div v-if="isOwner" class="shop__button--edit" @click="togglePopupEditImpressum">{{
          $t("shop_editShopAccount")
        }}
      </div>
      <p>
        <strong>{{ shopImpressum.firma }}</strong><br/>
        {{ $t("shop_vertretenDurch") }} {{ shopImpressum.ansprechpartner }}<br/>
        {{ shopImpressum.strasse }}<br/>
        {{ shopImpressum.iso3166 }} {{ shopImpressum.plz }} {{ shopImpressum.ort }}
      </p>
      <ClientOnly><p>{{ $t("konf_Email") }}: {{ decodedEmail }}<br/>
        {{ $t("konf_Tel") }}: {{ shopImpressum.telefon }}
      </p></ClientOnly>
      <p>
        <strong>{{ $t("shop_technischeRealisierung") }}</strong><br/>
        <span v-html='$t("shop_technischeRealisierungDesc")'></span>
      </p>
      <div v-html="owayoImpressumContent"></div>
    </div>

    <div class="footer-impressum">
      <NuxtLink :to="getRouteWithprefix('')">
        <button class="closeDrafts km__button--standard">{{ $t("konf_Back") }}</button>
      </NuxtLink>
    </div>
  </div>
</template>

<script lang="ts">
import {computed} from "vue";
import {PopupNames, PopupStatus} from "~/components/PopupHandler";
import {getRouteWithprefix} from "~/_router/routeUtils";
import {useShopInfos} from "~/store/shopInfosStore";
import {useFooterStore} from "~/store/FooterStore";

const rot13 = (s:string)=>s.replace(/[a-zA-Z]/g,function(c){return String.fromCharCode((c<="Z"?90:122)>=(c=c.charCodeAt(0)+13)?c:c-26);});
export default {
  name: "Impressum",
  props: {
    isOwner: Boolean
  },
  setup() {
    const shopInfos = useShopInfos();
    const footerStore = useFooterStore();
    function togglePopupEditImpressum() {
      PopupStatus.TOGGLE_POPUP(PopupNames.editImpressum);
    }
    const shopImpressum = computed(() => shopInfos.getShopImpressum);
    const encodedEmail = computed(()=>shopImpressum.value.rot13Email);
    const decodedEmail = computed(()=>rot13(encodedEmail.value))

    return {
      decodedEmail,
      owayoImpressumContent: computed(() => footerStore.getOwayoImpressum),
      shopImpressum: shopImpressum,
      togglePopupEditImpressum,
      getRouteWithprefix
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~/assets/scss/settings/_config.scss" as *;
.impressum {
  h1 {
    font-weight: 700;
    margin-bottom: 20px;
    position: relative;
  }

  strong {
    font-weight: 600;
  }

  .shop__button--edit {
    margin-bottom: 20px;
    width: 300px;
  }
}

:deep(strong) {
  font-weight: 600;
}

.btn-back {
  background: $color-blue;
  width: 200px;
  text-align: center;
  color: white;
  padding: 10px;
  display: block;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
}

.footer-impressum {
  padding: 40px;
  display: flex;
  justify-content: center;
  column-gap: 25px;
  width: 100%;

  .km__button--standard {
    width: 220px;
  }
}

</style>
